import React from 'react';
import { RotateCcw, PackageX, Mail, Tag } from 'lucide-react';
export function ReturnPolicyPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-514">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-515">
        <div className="max-w-4xl mx-auto text-center" data-id="element-516">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-517">
            <RotateCcw className="w-8 h-8 text-[#0e7be1]" data-id="element-518" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-519">
              Return Policy
            </h1>
          </div>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full" data-id="element-520"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-521">
        <div className="prose prose-lg max-w-none space-y-8" data-id="element-522">
          {/* General Returns */}
          <section data-id="element-523">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-524">
              General Returns
            </h2>
            <p className="text-gray-600 leading-relaxed" data-id="element-525">
              If you are not satisfied with your purchase for any reason, you
              may return the item to us in its original packaging with your
              invoice within 30 days of delivery for a full refund for the total
              amount of the order, less shipping.
            </p>
          </section>

          {/* Returned Packages */}
          <section data-id="element-526">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-527">
              Returned Packages
            </h2>
            <p className="text-gray-600 leading-relaxed" data-id="element-528">
              If a package is returned to us after 3 delivery attempts, returned
              due to an incorrect/incomplete address or refused at delivery, you
              will be refunded for the total amount of the order, less shipping,
              and a 15% restocking fee.
            </p>
          </section>

          {/* Damaged or Mis-shipped Items */}
          <section className="bg-blue-50 border-l-4 border-[#0e7be1] p-6 rounded-r-lg" data-id="element-529">
            <div className="flex items-start gap-3 mb-3" data-id="element-530">
              <Mail className="w-6 h-6 text-[#0e7be1] flex-shrink-0 mt-0.5" data-id="element-531" />
              <h2 className="text-xl font-bold text-gray-900" data-id="element-532">
                Damaged or Mis-shipped Items
              </h2>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-533">
              If you are returning items that are damaged, mis-shipped or the
              result of an error on our part, you will be refunded the total
              amount of the order and we'll pay the return shipping costs.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-534">
              Items should be returned in their original product packaging,
              include a copy of the invoice and a brief description of the
              problem. Email us or call us so we may guide you through the
              process and even supply you with a return mailing label.
            </p>
          </section>

          {/* Missing Items */}
          <section data-id="element-535">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-536">
              Missing Items
            </h2>
            <p className="text-gray-600 leading-relaxed" data-id="element-537">
              Refunds for items reported as missing by the customer that are
              indicated as shipped will not be refunded. However, we will review
              on a case by case basis, at our sole discretion. Our final
              determination is typically based on customer history and final
              shipping weights.
            </p>
          </section>

          {/* Non-Returnable Items */}
          <section className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-538">
            <div className="flex items-start gap-3 mb-4" data-id="element-539">
              <PackageX className="w-6 h-6 text-gray-700 flex-shrink-0 mt-0.5" data-id="element-540" />
              <h2 className="text-xl font-bold text-gray-900" data-id="element-541">
                Non-Returnable Items
              </h2>
            </div>
            <p className="text-gray-600 mb-4" data-id="element-542">
              For your safety, we do not accept returns of the following items:
            </p>
            <ul className="space-y-3" data-id="element-543">
              <li className="flex items-start gap-3 text-gray-700" data-id="element-544">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-545"></span>
                Any item that is not in its original condition, is damaged, or
                is missing parts for reasons not due to our error
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-546">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-547"></span>
                Any item that is not returned within 30 days of shipment
              </li>
            </ul>
          </section>

          {/* Return Shipping Label */}
          <section data-id="element-548">
            <div className="flex items-start gap-3 mb-4" data-id="element-549">
              <Tag className="w-6 h-6 text-[#0e7be1] flex-shrink-0 mt-0.5" data-id="element-550" />
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-551">
                Return Shipping Label
              </h2>
            </div>
            <p className="text-gray-600 leading-relaxed" data-id="element-552">
              If you use the mailing label and the return is a result of our
              error (you received an incorrect or defective item, etc.) we'll
              pay the return shipping cost regardless of what it is.
            </p>
          </section>
        </div>
      </div>
    </div>;
}